import React, { useState } from 'react';

const ChevronIcon = ({ isOpen }) => (
  <svg
    className={`w-4 h-4 shrink-0 text-gray-400 transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`}
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
  >
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
  </svg>
);

// ヘルプページのコンテンツデータ（カテゴリ → タイトル → サブタイトル の3階層）
const helpData = [
  {
    category: '使い方',
    titles: [
      {
        title: 'エレベータの呼び方について',
        description: '今いる階と行きたい階を選択することでエレベータを呼ぶことができます。呼び出したエレベータは自動的に行きたい階が登録され、かご内での操作が不要になります。',
        subtitles: [
          {
            subtitle: '事前登録：マイエレベータに追加',
            detail: (
              <div className="space-y-1 text-sm text-gray-700">
                <p>①エレベータホールに移動する</p>
                <p>②QRコードを読み込む。</p>
                <p className="pl-3">またはエレベータ内の操作盤に貼られているラベルに記載されている登録番号※を確認し、登録番号入力欄に登録番号(ハイフンなし)を入力する</p>
                <p className="pl-3 text-xs text-gray-500">※ラベル記載の7桁の番号です。ラベルがない場合、エレベータの所有者・管理者にお問い合わせください。</p>
                <p>③マイエレベータ名を入力する</p>
                <p className="pl-3 text-xs text-gray-500">※マイエレベータに追加すると、前回呼び出しの情報が記憶されるため、次回以降は②③を省略することができます。追加しない場合は都度登録番号の入力が必要になります。</p>
                <p className="pt-2 text-xs text-gray-400">※QRコードは、(株)デンソーウェーブの登録商標です。</p>
              </div>
            ),
          },
          {
            subtitle: 'マイエレベータを呼ぶ',
            detail: (
              <div className="space-y-1 text-sm text-gray-700">
                <p>①エレベータホールに移動する</p>
                <p>②登録番号入力欄右の★ボタンを押し、マイエレベータ一覧から利用するマイエレベータ名を選択</p>
                <p>③今いる階と行きたい階を選択、または行先方向矢印アイコンをタップし今いる階と行きたい階を入れ替える</p>
                <p>④呼ぶボタンを押す(位置情報の共有をONにする)</p>
                <p>⑤乗場ボタンが点灯し、エレベータ呼びの完了画面が表示され、エレベータが移動する</p>
                <p>⑥到着したエレベータに乗る</p>
              </div>
            ),
          },
          {
            subtitle: '車いす利用モード',
            detail: (
              <div className="space-y-1 text-sm text-gray-700">
                <p>車いすアイコンをタップすると車いす利用モードでエレベータを呼び出します。</p>
                <p>呼び出しされたエレベータは扉の開いてる時間が通常より長く、扉がゆっくり閉まります。</p>
                <p className="text-xs text-gray-500">※車いす仕様のエレベータではない場合、車いすアイコンは表示されません。</p>
                <div className="pt-2">
                  <div className="flex items-center space-x-6">
                    <div className="flex items-center space-x-2">
                      <img src="./assets/static/W_OFF.png" className="h-8 w-8" alt="OFF" />
                      <span className="text-sm">OFF</span>
                    </div>
                    <div className="flex items-center space-x-2">
                      <img src="./assets/static/W_ON.png" className="h-8 w-8 ux-bg-blue rounded" alt="ON" />
                      <span className="text-sm">ON</span>
                    </div>
                  </div>
                </div>
              </div>
            ),
          },
        ],
      },
      {
        title: 'エレベータの管理について',
        description: (
          <div className="space-y-2 text-sm text-gray-700">
            <p>よく利用するエレベータをマイエレベータとして追加することで、登録番号の入力が不要となります。また、前回エレベータを呼び出した際の階数が表示される等、一部操作を省略できます。</p>
            <div className="pt-1">
              <p>①登録番号入力欄右の★ボタンを押す</p>
              <p>②マイエレベータ一覧を確認する</p>
            </div>
            <div className="pt-2 pl-2 space-y-3">
              <div>
                <p className="font-semibold">マイエレベータ名を変更する</p>
                <p>①ペンアイコンを押す</p>
                <p>②新しいマイエレベータ名を入力する</p>
                <p>③保存を押す</p>
              </div>
              <div>
                <p className="font-semibold">登録番号を確認する</p>
                <p>①インフォメーションアイコンを押す</p>
                <p>②登録番号を確認する</p>
              </div>
              <div>
                <p className="font-semibold">マイエレベータから削除する</p>
                <p>①削除アイコンを押す</p>
                <p>②削除を押す</p>
              </div>
            </div>
          </div>
        ),
        subtitles: [],
      },
      {
        title: 'エレベータの運行状況の確認方法について',
        description: (
          <div className="space-y-2 text-sm text-gray-700">
            <p>エレベータの運行状況を表示します。</p>
            <p>表示内容は以下の4種類です。</p>
            <div className="pl-2 space-y-3 pt-1">
              <div>
                <p className="font-semibold">A.通常運転中</p>
                <p>エレベータの状態に問題はありません。</p>
                <p className="text-xs text-gray-500">※乗場の案内と情報が異なる場合は乗場の案内に従ってください。</p>
                <p className="text-xs text-gray-500">※定期点検や１日工事などを行う停止予定日期間内も本表示となる可能性があります。また、作業が終了する時間は前後する場合があります。</p>
              </div>
              <div>
                <p className="font-semibold">B.運転休止中</p>
                <p>地震や浸水などの緊急時は安全確保を目的としてエレベータを休止しており、ご利用できません。準備が整い次第係員を派遣しますので、復旧までしばらくお待ちください。</p>
                <p className="text-xs text-gray-500">※作業が終了する時間は前後する場合があります。</p>
              </div>
              <div>
                <p className="font-semibold">C.仮復旧運転中</p>
                <p>地震や浸水など緊急事態発生後、しばらく休止していましたが、復旧作業を行い安全な速度で運転を再開しています。</p>
              </div>
              <div>
                <p className="font-semibold">D.点検中</p>
                <p>点検作業中のため、エレベータをご利用できません。作業終了までしばらくお待ちください。</p>
                <p className="text-xs text-gray-500">※作業が終了する時間は前後する場合があります。</p>
              </div>
            </div>
            <div className="pt-2">
              <p className="font-semibold">確認方法</p>
              <p>①登録番号入力欄から、マイエレベータ名を選択または登録番号を入力する</p>
              <p>②画面を左右にスライドし、運行状況画面を確認する</p>
            </div>
          </div>
        ),
        subtitles: [],
      },
      {
        title: '停止予定日の確認方法と変更通知について',
        description: (
          <div className="space-y-2 text-sm text-gray-700">
            <p>登録したエレベータが定期点検や1日工事などで停止する予定の日時をご確認できます。</p>
            <p>以下のような場合、案内した停止日時と実際の停止日時が異なることがあります。</p>
            <div className="pl-2">
              <p>A.作業の内容によって終了予定時刻になっても終わっていないケース</p>
              <p>B.地震・浸水などの災害時</p>
              <p>C.急な予定変更による停止作業の延期・キャンセル</p>
            </div>
            <div className="pt-2">
              <p className="font-semibold">確認方法</p>
              <p>①登録番号入力欄から、マイエレベータ名を選択または登録番号を入力する</p>
              <p>②画面を左右スワイプし、次回停止予定日を確認する</p>
            </div>
          </div>
        ),
        subtitles: [
          {
            subtitle: '変更通知のON・OFFを選択する',
            detail: (
              <div className="space-y-2 text-sm text-gray-700">
                <p>変更通知をONにすると停止予定日の日時変更がある場合、LINEメッセージにて通知します。</p>
                <div>
                  <p className="font-semibold pt-1">ONにする</p>
                  <p>①登録番号入力欄から、マイエレベータ名を選択または登録番号を入力する</p>
                  <p>②画面を左右にスライドし、次回停止予定日画面の変更通知ボタンを押す</p>
                  <p>③確認画面で「OK」を選択する</p>
                  <p>④日時変更があった場合、LINEメッセージに変更通知が届く</p>
                </div>
                <div>
                  <p className="font-semibold pt-1">OFFにする</p>
                  <p>①登録番号入力欄から、マイエレベータ名を選択または登録番号を入力する</p>
                  <p>②画面を左右にスライドし、次回停止予定日画面の変更通知ボタンを押す</p>
                  <p>③確認画面で「OK」を選択する</p>
                </div>
                <p className="pt-2 text-xs text-gray-400">※LINEは、LINEヤフー株式会社の登録商標です。</p>
              </div>
            ),
          },
        ],
      },
    ],
  },
  {
    category: 'よくある問い合わせ',
    titles: [
      {
        title: '利用全般について',
        description: '',
        subtitles: [
          {
            subtitle: 'Q：どんな機能がありますか',
            detail: (
              <div className="space-y-1 text-sm text-gray-700">
                <p>A: 本サービスでは以下の3種類の機能をご利用いただけます。詳しくは【使い方】をご参照ください。</p>
                <p className="pl-3">①エレベータの呼び出し</p>
                <p className="pl-3">②エレベータの運行状況の確認</p>
                <p className="pl-3">③次回停止予定日の確認と変更通知</p>
              </div>
            ),
          },
          {
            subtitle: 'Q：スマートフォンの設定は必要ですか',
            detail: (
              <div className="space-y-1 text-sm text-gray-700">
                <p>A: エレベータを呼び出す機能をご利用の場合は以下の設定を行ってください。</p>
                <p className="font-semibold pt-1">[位置情報へのアクセス許可]</p>
                <p>スマートフォンの設定アプリから許可を行うか、呼び出しボタン押下後に表示される位置情報アクセス許可を求める画面にて許可を行ってください。</p>
              </div>
            ),
          },
          {
            subtitle: 'Q：本サービスは無料で利用できますか',
            detail: (
              <div className="space-y-1 text-sm text-gray-700">
                <p>A: 無料でご利用いただけます。</p>
                <p className="pl-3">ただし、通信料はお客様のご負担となります。</p>
              </div>
            ),
          },
          {
            subtitle: 'Q：本サービスは、どのエレベータで使えますか',
            detail: (
              <p className="text-sm text-gray-700">A：本サービスは、管理者が利用を許可している、当社製のエレベータでのみご利用いただけます。</p>
            ),
          },
        ],
      },
      {
        title: 'エレベータの呼び出しについて',
        description: '',
        subtitles: [
          {
            subtitle: 'Q：エレベータを呼び出しできません',
            detail: (
              <div className="space-y-2 text-sm text-gray-700">
                <p>A: 以下の原因が考えられます。この場合は、直接乗場のボタンを操作してください。</p>
                <div className="pl-2 space-y-2">
                  <div>
                    <p className="font-semibold">①通信環境の問題</p>
                    <p>通信環境をお確かめください。周辺の状況によっては通信が届きにくい場合があります。</p>
                  </div>
                  <div>
                    <p className="font-semibold">②位置情報へのアクセス許可がないまたは位置情報を正常に検出できない</p>
                    <p>スマートフォンの設定アプリから許可を行うか、呼び出しボタン押下後に表示される位置情報アクセス許可を求める画面にて許可を行ってください。位置情報を正常に検知できない場合は、①をご確認ください。</p>
                  </div>
                  <div>
                    <p className="font-semibold">③通常運転中ではない</p>
                    <p>管制運転や点検中などのため、現在エレベータがご利用できない場合があります。</p>
                    <p className="text-xs text-gray-500">※詳細は「エレベータの運行状況の確認」をご参照ください</p>
                  </div>
                  <div>
                    <p className="font-semibold">④連続操作による使用制限</p>
                    <p>一定時間に連続で呼び出しを行うと1分間呼び出しを行うことができません。呼ぶボタンが有効になるまでしばらくお待ちください。</p>
                  </div>
                  <div>
                    <p className="font-semibold">⑤エレベータの所有者・管理者による本サービスの制限</p>
                  </div>
                  <div>
                    <p className="font-semibold">⑥その他の原因</p>
                    <p>スマートフォンによる呼び出しのアクセスの集中や弊社サーバーシステムの障害などのため、ご利用できません。しばらくしてから再度呼び出してください。</p>
                  </div>
                </div>
              </div>
            ),
          },
          {
            subtitle: 'Q：エレベータ呼びの完了画面が表示されたのにエレベータが到着していません',
            detail: (
              <p className="text-sm text-gray-700">A: 今いる階が正しく選択されているかご確認ください。エレベータホールにて乗場ボタンが点灯しているかを確認し、点灯していない場合は再度呼び出してください。エラーメッセージが出る場合は内容をご確認後、しばらくしてからご利用ください。</p>
            ),
          },
          {
            subtitle: 'Q：一部の階が選択できません',
            detail: (
              <p className="text-sm text-gray-700">A: 不停止設定（セキュリティロック）がかかっている階は、スマートフォンからも行先階登録できません。</p>
            ),
          },
        ],
      },
    ],
  },
];

const HelpPage = ({ onShowTutorial }) => {
  const [openTitles, setOpenTitles] = useState({});
  const [openSubtitles, setOpenSubtitles] = useState({});

  const toggleTitle = (key) => {
    setOpenTitles(prev => ({ ...prev, [key]: !prev[key] }));
  };

  const toggleSubtitle = (key) => {
    setOpenSubtitles(prev => ({ ...prev, [key]: !prev[key] }));
  };

  return (
    <div className="w-full bg-white swiper-slide-rd">
      <div className="w-full bg-white rounded-2xl shadow-lg flex flex-col relative">

        {/* Content Area - MainPageのFloor Selection Areaと同じ高さでスクロール可能 */}
        <div className="flex-grow h-[calc(100svh/45*32)] my-[calc(100svh/45*2)] mx-[calc(100vw/24)] overflow-y-auto no-scrollbar" style={{ touchAction: 'pan-y' }}>

          {helpData.map((cat, catIdx) => (
            <div key={catIdx} className={catIdx > 0 ? 'mt-6' : ''}>
              {/* カテゴリヘッダー */}
              <p className="text-xs text-gray-500 font-semibold pb-1">{cat.category}</p>
              <div className="border-t-2" />

              {cat.titles.map((item, titleIdx) => {
                const titleKey = `${catIdx}-${titleIdx}`;
                const isTitleOpen = !!openTitles[titleKey];

                return (
                  <div key={titleIdx}>
                    {/* タイトル（アコーディオンヘッダー） */}
                    <button
                      onClick={() => toggleTitle(titleKey)}
                      className="w-full flex items-center py-3 text-left active:opacity-50 transition-opacity"
                    >
                      <ChevronIcon isOpen={isTitleOpen} />
                      <span className="ml-2 font-bold text-gray-800 text-sm leading-snug">{item.title}</span>
                    </button>

                    {/* タイトル下線（常に表示） */}
                    <div className="border-t-2" />

                    {isTitleOpen && (
                      <>
                        {/* タイトル詳細説明 */}
                        {item.description && (
                          <>
                            <div className="py-3 pl-6 leading-snug">
                              {typeof item.description === 'string'
                                ? <p className="text-sm text-gray-600">{item.description}</p>
                                : item.description
                              }
                            </div>
                            <div className="border-t-2" />
                          </>
                        )}

                        {/* サブタイトル（子アコーディオン） */}
                        {item.subtitles.map((sub, subIdx) => {
                          const subKey = `${catIdx}-${titleIdx}-${subIdx}`;
                          const isSubOpen = !!openSubtitles[subKey];

                          return (
                            <div key={subIdx}>
                              <button
                                onClick={() => toggleSubtitle(subKey)}
                                className="w-full flex items-center py-3 pl-4 text-left active:opacity-50 transition-opacity"
                              >
                                <ChevronIcon isOpen={isSubOpen} />
                                <span className="ml-2 text-gray-800 text-sm leading-snug">{sub.subtitle}</span>
                              </button>

                              {isSubOpen && (
                                <>
                                  <div className="border-t border-dashed border-gray-300 ml-4" />
                                  <div className="py-3 pl-8 pr-1">{sub.detail}</div>
                                </>
                              )}

                              <div className="border-t-2" />
                            </div>
                          );
                        })}
                      </>
                    )}
                  </div>
                );
              })}
            </div>
          ))}

          {/* フッターテキスト */}
          <p className="text-sm text-gray-500 mt-6 mb-4 leading-snug">
            詳細や操作に関するご質問は、ホームページ内のお問い合わせフォームよりお問い合わせください。
          </p>

          {/* チュートリアル再表示ボタン */}
          <section className="mb-4">
            <button
              onClick={onShowTutorial}
              className="w-full py-3 ux-bg-selected-now flex items-center justify-center space-x-2 ux-text-lightgray"
            >
              <span>チュートリアルを見る</span>
            </button>
          </section>
        </div>
      </div>
    </div>
  );
};

export default HelpPage;